import React, { forwardRef } from "react"
import { Link } from "@walmart-web/livingdesign-components"
import {
	Calendar,
	ChevronDown,
	ChevronUp,
} from "@walmart-web/livingdesign-icons"
import { CalendarInputProps } from "./MultiRangeCalendar.domain"
import { useApplicationContext } from "context/applicationContext"
import { formatRangesTextInput } from "./MultiRangeCalendar.utils"

const CalendarInput = forwardRef<HTMLAnchorElement, CalendarInputProps>(
	(props, inputReference) => {
		const { text, calendarRangesSelected, isOpen, ...restOfProps } = props
		const { locale } = useApplicationContext()
		const datesFormatted = formatRangesTextInput(calendarRangesSelected, locale)

		return (
			<Link
				data-testid="input-calendar"
				ref={inputReference}
				{...restOfProps}
				UNSAFE_className="multi-calendar-range__input-date"
			>
				<div className="multi-calendar-range__input-date__label">
					<Calendar />
					<span data-testid="calendar-label">{text}:</span>
				</div>
				<div className="multi-calendar-range__input-date__dates">
					{datesFormatted}
				</div>
				{isOpen ? (
					<ChevronUp a11yLabel="svg-chevron-up" />
				) : (
					<ChevronDown a11yLabel="svg-chevron-down" />
				)}
			</Link>
		)
	}
)

export default CalendarInput
